<template>
  <div class="about">
    <my-navi activeIndex="21"></my-navi>
    <el-container>
      <el-header>
        <span style="font-weight: bold; font-size: 16px;">AI模型设置</span>
      </el-header>
      <el-main v-loading="loading">
        <el-card>
          <el-alert
            v-if="!isAdmin"
            title="当前账号为普通用户，仅可查看模型配置。如需修改，请联系管理员。"
            type="info"
            :closable="false"
            show-icon
            style="margin-bottom: 20px;"
          ></el-alert>
          <el-alert
            v-else
            title="管理员模式：修改模型名称后点击“保存”，保存后立即对所有AI功能生效。"
            type="success"
            :closable="false"
            show-icon
            style="margin-bottom: 20px;"
          ></el-alert>

          <el-table :data="settingList" border stripe>
            <el-table-column label="配置项" width="220px">
              <template slot-scope="scope">
                <div style="font-weight: bold;">{{ scope.row.label }}</div>
                <div style="color: #909399; font-size: 12px;">{{ scope.row.key }}</div>
              </template>
            </el-table-column>
            <el-table-column label="用途" prop="usage" width="320px"></el-table-column>
            <el-table-column label="当前模型">
              <template slot-scope="scope">
                <el-input
                  v-if="isAdmin"
                  v-model="editingValues[scope.row.key]"
                  size="small"
                  placeholder="请输入模型名称"
                  clearable
                ></el-input>
                <span v-else style="font-family: monospace;">{{
                  scope.row.value
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="默认值" width="180px">
              <template slot-scope="scope">
                <span style="color: #909399; font-family: monospace;">{{
                  scope.row.defaultValue
                }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="isAdmin" label="操作" width="180px">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  :loading="savingKey === scope.row.key"
                  :disabled="!editingValues[scope.row.key] || editingValues[scope.row.key] === scope.row.value"
                  @click="saveSetting(scope.row)"
                >
                  保存
                </el-button>
                <el-button
                  size="small"
                  @click="resetDefault(scope.row)"
                >
                  恢复默认
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import {
  AI_SETTING_ITEMS,
  getAiSettings,
  setAiSetting
} from "../js/aiSettings.js";

export default {
  name: "AiSettings",
  data() {
    return {
      loading: false,
      savingKey: "",
      settingList: [],
      editingValues: {}
    };
  },
  computed: {
    isAdmin() {
      return !!(
        this.$store.state.userinfo && this.$store.state.userinfo.is_admin > 0
      );
    }
  },
  created() {
    this.fetchSettings();
  },
  methods: {
    async fetchSettings() {
      this.loading = true;
      try {
        const settings = await getAiSettings(true);
        this.settingList = AI_SETTING_ITEMS.map(item => ({
          ...item,
          value: settings[item.key] || item.defaultValue
        }));
        this.editingValues = {};
        this.settingList.forEach(item => {
          this.$set(this.editingValues, item.key, item.value);
        });
      } catch (error) {
        this.$message.error(
          "获取AI配置失败：" +
            (error.response && error.response.data
              ? JSON.stringify(error.response.data)
              : error.message || "未知错误")
        );
      } finally {
        this.loading = false;
      }
    },

    async saveSetting(row) {
      const value = (this.editingValues[row.key] || "").trim();
      if (!value) {
        this.$message.warning("模型名称不能为空");
        return;
      }
      this.savingKey = row.key;
      try {
        await setAiSetting(row.key, value);
        this.$message.success(`${row.label}已更新为 ${value}`);
        await this.fetchSettings();
      } catch (error) {
        this.$message.error(
          "保存失败：" +
            (error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : error.message || "未知错误")
        );
      } finally {
        this.savingKey = "";
      }
    },

    resetDefault(row) {
      this.$set(this.editingValues, row.key, row.defaultValue);
    }
  }
};
</script>
